<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card
      class="mb-2"
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h4 class="mb-25">
            <feather-icon
              icon="FilterIcon"
              size="18"
              class="mr-50"
            />
            Resumen del periodo
          </h4>

          <small class="text-muted">
            Selecciona el plan y periodo que deseas consultar
          </small>
        </div>
      </div>

      <b-row align-v="end">

        <!-- Plan -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Plan de estudios"
            class="mb-md-0"
          >
            <plan-select
              :plan-id.sync="localPlan"
              :liberar-planes="true"
            />
          </b-form-group>
        </b-col>

        <!-- Periodo -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Periodo"
            class="mb-md-0"
          >
            <periodo-select
              :periodo-id.sync="localPeriodo"
              :auto-select-first="true"
              :plan-id="localPlan"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BOverlay,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import PlanSelect from '@/@core/components/selects/PlaneSelect.vue'
import PeriodoSelect from '@/@core/components/selects/PeriodoSelect.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    PlanSelect,
    PeriodoSelect,
    BOverlay,
  },
  props: {
    planFilter: {
      type: Number,
      default: null,
    },
    periodoFilter: {
      type: Number,
      default: null,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const localPlan = computed({
      get: () => props.planFilter,
      set: val => {
        if (val === props.planFilter) return

        emit('update:planFilter', val)
        emit('update:periodoFilter', null)
      },
    })

    const localPeriodo = computed({
      get: () => props.periodoFilter,
      set: val => {
        if (val === props.periodoFilter) return

        emit('update:periodoFilter', val)
      },
    })

    return {
      localPlan,
      localPeriodo,
    }
  },
}
</script>
